import type { ReactNode } from "react";
import { BoardTruncatedText } from "@design-system/Board/BoardTruncatedText";
import { LiveDot } from "@design-system/LiveDot/LiveDot";
import styles from "./ActivityList.module.scss";

export interface ActivityListItem {
    id: string;
    /** An avatar or 12px icon for who acted; the row sizes an avatar to 12px. */
    icon: ReactNode;
    label: ReactNode;
    /** A short relative time, such as "24m". */
    time?: ReactNode;
    /** Happening now: a live dot instead of the time. */
    isLive?: boolean;
    /** Replaces the live dot or time with the caller's own end slot. */
    trailing?: ReactNode;
}

interface ActivityRowProps {
    item: ActivityListItem;
    /** Draws the rail from under this icon down to the next row. */
    hasConnector: boolean;
}

const renderTrailing = (item: ActivityListItem) => {
    if (item.trailing !== undefined) {
        return item.trailing;
    }
    if (item.isLive) {
        return <LiveDot size="xs" variant="accent" className={styles.live} />;
    }
    return (
        item.time !== undefined && (
            <span className={styles.time}>{item.time}</span>
        )
    );
};

export const ActivityRow = ({ item, hasConnector }: ActivityRowProps) => (
    <span className={styles.row}>
        <span
            className={styles.icon}
            data-connector={hasConnector || undefined}
        >
            {item.icon}
        </span>
        <BoardTruncatedText className={styles.label}>
            {item.label}
        </BoardTruncatedText>
        {renderTrailing(item)}
    </span>
);
